import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import hasInterface from '../../../../hasInterface';
import Coordinate from './Coordinate';
import Double from '../../../../java/lang/Double';
import CoordinateSequence from './CoordinateSequence';
var CoordinateSequences = /*#__PURE__*/function () {
  function CoordinateSequences() {
    _classCallCheck(this, CoordinateSequences);
  }
  _createClass(CoordinateSequences, null, [{
    key: "copyCoord",
    value: function copyCoord(src, srcPos, dest, destPos) {
      var minDim = Math.min(src.getDimension(), dest.getDimension());
      for (var dim = 0; dim < minDim; dim++) dest.setOrdinate(destPos, dim, src.getOrdinate(srcPos, dim));
    }
  }, {
    key: "isRing",
    value: function isRing(seq) {
      var n = seq.size();
      if (n === 0) return true;
      if (n <= 3) return false;
      return seq.getOrdinate(0, CoordinateSequence.X) === seq.getOrdinate(n - 1, CoordinateSequence.X) && seq.getOrdinate(0, CoordinateSequence.Y) === seq.getOrdinate(n - 1, CoordinateSequence.Y);
    }
  }, {
    key: "scroll",
    value: function scroll() {
      if (arguments.length === 2) {
        if (hasInterface(arguments[0], CoordinateSequence) && Number.isInteger(arguments[1])) {
          var seq = arguments[0],
            indexOfFirstCoordinate = arguments[1];
          CoordinateSequences.scroll(seq, indexOfFirstCoordinate, CoordinateSequences.isRing(seq));
        } else if (hasInterface(arguments[0], CoordinateSequence) && arguments[1] instanceof Coordinate) {
          var _seq = arguments[0],
            firstCoordinate = arguments[1];
          var i = CoordinateSequences.indexOf(firstCoordinate, _seq);
          if (i <= 0) return null;
          CoordinateSequences.scroll(_seq, i);
        }
      } else if (arguments.length === 3) {
        var _seq2 = arguments[0],
          _indexOfFirstCoordinate = arguments[1],
          ensureRing = arguments[2];
        var _i = _indexOfFirstCoordinate;
        if (_i <= 0) return null;
        var copy = _seq2.copy();
        var last = ensureRing ? _seq2.size() - 1 : _seq2.size();
        for (var j = 0; j < last; j++) for (var k = 0; k < _seq2.getDimension(); k++) _seq2.setOrdinate(j, k, copy.getOrdinate((_indexOfFirstCoordinate + j) % last, k));
        if (ensureRing) for (var _k = 0; _k < _seq2.getDimension(); _k++) _seq2.setOrdinate(last, _k, _seq2.getOrdinate(0, _k));
      }
    }
  }, {
    key: "isEqual",
    value: function isEqual(cs1, cs2) {
      var cs1Size = cs1.size();
      var cs2Size = cs2.size();
      if (cs1Size !== cs2Size) return false;
      var dim = Math.min(cs1.getDimension(), cs2.getDimension());
      for (var i = 0; i < cs1Size; i++) for (var d = 0; d < dim; d++) {
        var v1 = cs1.getOrdinate(i, d);
        var v2 = cs2.getOrdinate(i, d);
        if (cs1.getOrdinate(i, d) === cs2.getOrdinate(i, d)) continue;
        if (Double.isNaN(v1) && Double.isNaN(v2)) continue;
        return false;
      }
      return true;
    }
  }, {
    key: "minCoordinateIndex",
    value: function minCoordinateIndex() {
      if (arguments.length === 1) {
        var seq = arguments[0];
        return CoordinateSequences.minCoordinateIndex(seq, 0, seq.size() - 1);
      } else if (arguments.length === 3) {
        var _seq3 = arguments[0],
          from = arguments[1],
          to = arguments[2];
        var minCoordIndex = -1;
        var minCoord = null;
        for (var i = from; i <= to; i++) {
          var testCoord = _seq3.getCoordinate(i);
          if (minCoord === null || minCoord.compareTo(testCoord) > 0) {
            minCoord = testCoord;
            minCoordIndex = i;
          }
        }
        return minCoordIndex;
      }
    }
  }, {
    key: "extend",
    value: function extend(fact, seq, size) {
      var newseq = fact.create(size, seq.getDimension());
      var n = seq.size();
      CoordinateSequences.copy(seq, 0, newseq, 0, n);
      if (n > 0) for (var i = n; i < size; i++) CoordinateSequences.copy(seq, n - 1, newseq, i, 1);
      return newseq;
    }
  }, {
    key: "reverse",
    value: function reverse(seq) {
      var last = seq.size() - 1;
      var mid = Math.trunc(last / 2);
      for (var i = 0; i <= mid; i++) CoordinateSequences.swap(seq, i, last - i);
    }
  }, {
    key: "swap",
    value: function swap(seq, i, j) {
      if (i === j) return null;
      for (var dim = 0; dim < seq.getDimension(); dim++) {
        var tmp = seq.getOrdinate(i, dim);
        seq.setOrdinate(i, dim, seq.getOrdinate(j, dim));
        seq.setOrdinate(j, dim, tmp);
      }
    }
  }, {
    key: "copy",
    value: function copy(src, srcPos, dest, destPos, length) {
      for (var i = 0; i < length; i++) CoordinateSequences.copyCoord(src, srcPos + i, dest, destPos + i);
    }
  }, {
    key: "ensureValidRing",
    value: function ensureValidRing(fact, seq) {
      var n = seq.size();
      if (n === 0) return seq;
      if (n <= 3) return CoordinateSequences.createClosedRing(fact, seq, 4);
      var isClosed = seq.getOrdinate(0, CoordinateSequence.X) === seq.getOrdinate(n - 1, CoordinateSequence.X) && seq.getOrdinate(0, CoordinateSequence.Y) === seq.getOrdinate(n - 1, CoordinateSequence.Y);
      if (isClosed) return seq;
      return CoordinateSequences.createClosedRing(fact, seq, n + 1);
    }
  }, {
    key: "indexOf",
    value: function indexOf(coordinate, seq) {
      for (var i = 0; i < seq.size(); i++) if (coordinate.x === seq.getOrdinate(i, CoordinateSequence.X) && coordinate.y === seq.getOrdinate(i, CoordinateSequence.Y)) return i;
      return -1;
    }
  }, {
    key: "createClosedRing",
    value: function createClosedRing(fact, seq, size) {
      var newseq = fact.create(size, seq.getDimension());
      var n = seq.size();
      CoordinateSequences.copy(seq, 0, newseq, 0, n);
      for (var i = n; i < size; i++) CoordinateSequences.copy(seq, 0, newseq, i, 1);
      return newseq;
    }
  }, {
    key: "minCoordinate",
    value: function minCoordinate(seq) {
      var minCoord = null;
      for (var i = 0; i < seq.size(); i++) {
        var testCoord = seq.getCoordinate(i);
        if (minCoord === null || minCoord.compareTo(testCoord) > 0) minCoord = testCoord;
      }
      return minCoord;
    }
  }]);
  return CoordinateSequences;
}();
export { CoordinateSequences as default };